import * as React from 'react';
import { Box, Button, Dialog, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { AlertTriangle } from 'lucide-react';

interface ConflictModalProps {
  open: boolean;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConflictModal = ({ open, message, onConfirm, onCancel }: ConflictModalProps) => (
  <Dialog
    open={open}
    onClose={onCancel}
    sx={{zIndex: 1500}}
    PaperProps={{
      sx: {
        borderRadius: '16px',
        width: '90%',
        maxWidth: 450,
        p: 3,
        boxShadow: '0 25px 50px rgba(0,0,0,0.25)',
        overflow: 'visible',
      },
    }}
  >
    {/* Header */}
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
      <Box sx={{
        width: 40, height: 40, borderRadius: '50%',
        bgcolor: '#ffedd5',
        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
      }}>
        <AlertTriangle size={20} color="#f97316" aria-hidden />
      </Box>
      <Typography sx={{ fontWeight: 700, fontSize: 18, color: '#111827', lineHeight: 1.3 }}>
        Replace Existing Plan Selected?
      </Typography>
    </Box>

    {/* Message */}
    <Typography sx={{ fontSize: 14, color: '#4b5563', mb: 3, lineHeight: 1.7 }}>
      {message}
    </Typography>

    {/* Actions */}
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1.5 }}>
      <CancelBtn onClick={onCancel}>Cancel</CancelBtn>
      <ConfirmBtn onClick={onConfirm}>Continue &amp; Replace</ConfirmBtn>
    </Box>
  </Dialog>
);

// ─── Styled ───────────────────────────────────────────────────────────────────

const CancelBtn = styled(Button)({
  padding: '8px 16px',
  background: 'white',
  border: '1px solid #d1d5db',
  color: '#374151',
  height: 37,
  fontSize: 14,
  fontWeight: 700,
  borderRadius: 8,
  cursor: 'pointer',
  boxShadow: '0 1px 2px rgba(0,0,0,0.06)',
  transition: 'background 150ms',
  '&:hover': { background: '#f9fafb' },
});

const ConfirmBtn = styled(Button)({
  padding: '8px 16px',
  background: '#009689',
  border: 'none',
  color: 'white',
  height: 37,
  fontSize: 14,
  fontWeight: 700,
  borderRadius: 8,
  cursor: 'pointer',
  boxShadow: '0 1px 2px rgba(0,0,0,0.06)',
  transition: 'background 150ms',
  '&:hover': { background: '#008276' },
});
